// Field Notes — hardcoded starter posts in the founder's voice.
// Update this file (or ask me to) to add new posts.

export const POSTS = [
  {
    slug: 'twelve-winters-on-the-beat',
    title: 'Twelve winters on the beat — what really keeps you dry',
    excerpt:
      'Goretex marketing teams have never carried a brace of pheasants down a hill in horizontal sleet. Here\u2019s what twelve seasons taught me about staying dry that the catalogues won\u2019t.',
    date: '2026-01-12',
    readMins: 6,
    category: 'Field craft',
    coverImage:
      'https://images.unsplash.com/photo-1543007630-9710e4a00a20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjAzNzl8MHwxfHNlYXJjaHwxfHxzY290dGlzaCUyMHJhaW58ZW58MHx8fHwxNzgxNTE2OTQ4fDA&ixlib=rb-4.1.0&q=85&w=1600',
    body: [
      'When you\u2019ve spent enough winters out on the high beats of Highland Perthshire, you stop trusting the brochures. The fellas selling you their latest 28k-hydrostatic-head laminate have, generally speaking, never had to gralloch a hind in a January blizzard with a slipped neck-warmer and stiff fingers.',
      'Here\u2019s the secret nobody puts on a tech-spec sheet: it isn\u2019t the outer that keeps you dry. It\u2019s the system. Wax, wool, and the willingness to admit when it\u2019s time to turn back.',
      'A waxed cotton coat will outlast three of those plastic shells, and when the wax starts to crack at the elbows you re-wax it by the fire. It smells of pine and beeswax and old days. A laminate ages by failing.',
      'Wool next to skin. Always. Synthetics chill the moment they\u2019re wet, and they will be. Merino, ideally British. If you\u2019re asleep in a down bag on the wet hill, keep it inside a bivvy and never trust polyester to keep a cold night out.',
      'And the third lesson: turn back. The hill will be there next week. You won\u2019t be, if you push it.',
    ],
  },
  {
    slug: 'adaptive-cycling-the-trail-belongs-to-everyone',
    title: 'Adaptive cycling: the trail belongs to everyone',
    excerpt:
      'A rider I met last summer changed how I think about every frame we now stock. If a bike won\u2019t fit a calf-leg prosthetic, it isn\u2019t finished yet.',
    date: '2026-01-08',
    readMins: 4,
    category: 'Adaptive',
    coverImage:
      // Field Notes cover — swapped from the stock on-road cyclists
      // photo to the Eahora brochure-cover image.
      '/brand/brochure-cover.png',
    body: [
      'Most bikes aren\u2019t designed; they\u2019re inherited. The geometry that worked for a 5\u201910\u201d able-bodied man fifty years ago still drives every catalogue today, and most riders quietly compromise.',
      'A summer ago a lad rode up beside me on a Perthshire estate path with a calf-leg prosthetic and a trainer fitted to the pedal. He\u2019d been told three times the bike he wanted couldn\u2019t be modified. He\u2019d done it himself in his shed.',
      'Every frame we now ask Eahora to send us has to pass three quiet tests: a low step-over (under 16\u201d), adjustable crank length, and pedal mounts that can be replaced for trainers, hand-cranks, or recumbent attachments.',
      'It costs us nothing extra. It just requires asking. The mountain never asked anyone a question; we won\u2019t either.',
    ],
  },
  {
    slug: 'three-bothies-you-can-reach-by-ebike',
    title: 'Three bothies you can reach by e-bike (and why you should)',
    excerpt:
      'A weekend\u2019s wild camping with the assistance of a motor isn\u2019t cheating. It\u2019s how more people get to feel what we feel up there.',
    date: '2026-01-03',
    readMins: 5,
    category: 'Routes',
    coverImage:
      'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxiaXZ2eXxlbnwwfHx8fDE3ODE1MTY5NDh8MA&ixlib=rb-4.1.0&q=85&w=1600',
    body: [
      'There\u2019s a snobbery about pedal-assist that I\u2019ve never had much patience for. The hills don\u2019t care how you got up them, only whether you respected them when you arrived.',
      'Three bothies within reach of a 750Wh battery, even with a load, if you ride sensibly:',
      'Glas-allt-Shiel \u2014 on the south side of Loch Muick. A Victorian shooting lodge turned bothy, with deer that don\u2019t bother to look up at you anymore.',
      'Ryvoan \u2014 above Glenmore. Twenty minutes of pedalling that used to take an hour. Sit on the porch, listen for ptarmigan.',
      'Gelder Shiel \u2014 below the south face of Lochnagar. A long pull in, but every yard worth it.',
      'Wild camping in Scotland is a right \u2014 don\u2019t let anyone tell you otherwise \u2014 but it\u2019s also a privilege. Pack it in, pack it out. No fires above the heather line. Be the rider the next rider needs you to have been.',
    ],
  },
];
